import Wrapper from "../assets/wrappers/Milestone";

const Milestone = () => {
  return (
    <Wrapper>
      <div className="container">
        <div className="item">
          <p data-aos="zoom-in"> 7+</p>
          <div className="divider"></div>
          <span>years of experience </span>
        </div>
        <div className="item">
          <p data-aos="zoom-in"> 5k+ </p>
          <div className="divider"></div>
          <span>patients treated</span>
        </div>
        <div className="item">
          <p data-aos="zoom-in">15+ </p>
          <div className="divider"></div>
          <span>certified techniques</span>
        </div>
        <div className="item">
          <p data-aos="zoom-in">100% </p>
          <div className="divider"></div>
          <span>commitment to care</span>
        </div>
      </div>
    </Wrapper>
  );
};

export default Milestone;
